import { render, staticRenderFns } from "./StaffAutoComplete.vue?vue&type=template&id=dca55f44&"
import script from "./StaffAutoComplete.vue?vue&type=script&lang=js&"
export * from "./StaffAutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./StaffAutoComplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports